<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-demission/"
    paramsName="demission_tableau"
    :endpoint="endpoint"
    :getRefs="$refs"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component
        :is="path"
        :sas="sas"
        @validation-changed="setState(path, $event)"
        :ref="path"
        :endpoint="endpoint"
      >
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"

import Identification from "@/components/Formulaires/DemandeDemission/Identification"
import Demission from "@/components/Formulaires/DemandeDemission/Demission"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-demission",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "demission", code: "titre-etape-2", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    Identification,
    Demission
  }
}
</script>
